import { SnackBarService } from "src/app/services/common/snackBar.service";
import { TranslateService } from "@ngstack/translate";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { Component, OnInit, Inject } from "@angular/core";
import { IBranch } from "src/app/interfaces/branch";
import { BranchService } from "src/app/services/http/business/branch/branch.service";
import { ICourseType } from "src/app/interfaces/course-type";
import { CourseTypeService } from "src/app/services/http/business/course-type/course-type.service";
import { CIDService } from "src/app/services/common/cid.service";
import { HoldingService } from "src/app/services/http/business/holding/holding.service";
import { CompanyService } from "src/app/services/http/business/company/company.service";
import { MatSelect, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { ICompany } from "src/app/interfaces/company";
import { ILevelInfo } from "src/app/interfaces/levelInfo";
import { LevelPriceService } from "src/app/services/http/business/level-price/level-price.service";
import { ILevelPrice } from "src/app/interfaces/level-price";
import { SoundEnum } from "src/app/enums/sound.enum";
import * as moment from "jalali-moment";
import { ErrorsService } from "src/app/services/common/errors.service";
import { environment } from "src/environments/environment";
import { IError } from "src/app/interfaces/error.interface";

@Component({
  selector: "app-level-price-entry",
  templateUrl: "./level-price-entry.component.html",
  styleUrls: ["./level-price-entry.component.css"]
})
export class LevelPriceEntryComponent implements OnInit {
  packageId: any;
  param: any;
  errorList: IError[] = [];
  errObject: any;
  form: FormGroup;
  isOwner: boolean;
  errors = new Array();
  levelList: ILevelInfo;
  branchList: IBranch[];
  companyList: ICompany;
  courseTypeList: ICourseType[];

  constructor(
    private fb: FormBuilder,
    private cidService: CIDService,
    private snackBar: SnackBarService,
    public translate: TranslateService,
    private errorService: ErrorsService,
    private branchService: BranchService,
    private companyService: CompanyService,
    private holdingService: HoldingService,
    private levelPriceService: LevelPriceService,
    private courseTypeService: CourseTypeService,
    private dialogRef: MatDialogRef<LevelPriceEntryComponent>,

    @Inject(MAT_DIALOG_DATA) public data: any
  ) {

    // Code: "101"
    // ExpireDay: 95
    // Id: 20
    // IsActive: true
    // IsGraduatedLevel: false
    // MaxCapacity: 15
    // Name: "101"
    // PackageId: 2007
    // PackageName: "English Result"

    this.packageId = data.PackageId;
  }

  ngOnInit() {
    this.getCompanyList();
    this.checkOwner();
    if (!this.isOwner) {
      this.branchService.list(true).subscribe(res => {
        this.branchList = res.DataList;
        this.getCourseType();
      });
    }
    // this.getLevelList();
    this.createForm();
  }

  createForm() {
    this.form = this.fb.group({
      Id: [0],
      LevelId: [this.data.Id, Validators.compose([Validators.required])],
      BranchEncryptId: [null],
      Price: [null, Validators.compose([Validators.required])],
      CourseTypeId: [null, Validators.compose([Validators.required])],
      CreditStartDate: [null, Validators.compose([Validators.required])],
      ContainDiscount: [false, Validators.compose([Validators.required])]
    });
    if (this.data.editable) {
      this.form.controls['Id'].patchValue(this.data.Id);
      this.form.controls['LevelId'].patchValue(this.data.LevelId);
      this.form.controls['BranchEncryptId'].patchValue(this.data.BranchEncryptId);
      this.form.controls['Price'].patchValue(this.data.Price);
      this.form.controls['CourseTypeId'].patchValue(this.data.CourseTypeId);
      this.form.controls['CreditStartDate'].patchValue(this.data.CreditStartDate);
      this.form.controls['ContainDiscount'].patchValue(this.data.ContainDiscount);
    }
  }

  checkOwner() {
    this.holdingService.checkOwnerHolding().subscribe(res => {
      this.isOwner = res.IsOwner;
      this.getCompanyList();
    });
  }

  getCompanyList() {
    this.companyService.list(0, 0).subscribe(res => {
      this.companyList = res.DataList;
    });
  }

  loadBranch(e: MatSelect) {
    this.cidService.setCID(e.value);
    this.branchService.list(true).subscribe(res => {
      this.branchList = res.DataList;
      this.getCourseType();
    });
  }

  getCourseType() {
    this.courseTypeService.list(0, 0).subscribe(res => {
      this.courseTypeList = res.DataList;
    });
  }

  // getLevelList() {
  //   this.levelInfoService.getList(this.packageId).subscribe(res => {
  //     this.levelList = res.DataList;
  //   });
  // }

  onClose() {
    this.dialogRef.close();
  }

  submit(data: ILevelPrice) {
    this.errors = new Array();
    data.CreditStartDate = moment
      .from(data.CreditStartDate, "en")
      .utc(true)
      .format(environment.dateFormat);
    this.levelPriceService.add(data).subscribe(
      () => {
        //this.onClose();
        this.snackBar.OpenSnackBar(
          this.translate.get("success.registration"),
          "ok",
          5000,
          SoundEnum.beep
        );
      },
      error => {
        // this.errObject = this.errorService.getError(error);
        // this.param = this.errorService.objectError(this.errObject);
        // this.errors = this.errorService.returnError(error);
        this.errorList = this.errorService.getErrorList(error.error);
      }
    );
  }
}
